import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(() => {
    return {
        provide: {
            postalCode: (postalCode: string) => {
                // put empty string if no exist
                postalCode = postalCode || ''
                // remove all not digit
                postalCode = postalCode.replace(/\D+/g, '')
                // after 3 number put ' ' example: 969 72
                return `${postalCode.slice(0, 3)} ${postalCode.slice(3)}`
            },
        },
    }
})
